/*
* Created on Mar 24, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

const OrganizationDeleteSuccessComponent = ({setStandalone, setShowFooter}) => {
    const {t} = useTranslation();
    const history = useNavigate();

    useEffect(()=>{
        setStandalone(true);
        setShowFooter(true);
        window.localStorage.removeItem('currentOrg');
        return ()=>{
            setStandalone(false);
            setShowFooter(false);
        }
    },[]);

    return (
        <div className="content-section">
            <div className="section-head">{t('@Organization deleted@')}</div>
            <div className="section-body">
                <div className="text-wrap">{t('@Your organization has been permanently deleted.@')}</div>
                <div className="text-wrap">{t('@Although your organization is immediately delete, it may take longer to remove the old backup data by no longer than 6 months.@')}
                </div>
                <div className="text-wrap">{t('@Thank you for trying QNAP Cloud service.@')}</div>
            </div>
            <div className="section-footer clear">
                <div className="pull-right">
                    <div className="q-btn-group">
                        <button type="button" className="q-btn q-btn-primary q-btn-large" onClick={()=>window.location.href = '/'}>
                            {t('@Return to Organization Center@')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrganizationDeleteSuccessComponent;